const API_BASE_URL = "https://dev-core-8faaa8c08768.herokuapp.com/api";

export async function fetchFormStats() {
  try {
    const res = await fetch(`${API_BASE_URL}/stats`);
    const result = await res.json();

    if (!res.ok) {
      throw new Error(result.error || "Statistikani olib bo'lmadi");
    }

    return result;
  } catch (err) {
    console.error("fetchFormStats xato:", err.message);
    return null;
  }
}

export async function submitForm(data) {
  try {
    const res = await fetch(`${API_BASE_URL}/submit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ism: data.ism,
        category: data.category,
        guruh_raqami: data.guruh_raqami || "",
        telefon: data.telefon,
        izoh: data.izoh || "qoldirmagan",
        sahifa: data.sahifa || window.location.href,
      }),
    });

    const result = await res.json();

    if (!res.ok) {
      throw new Error(result.message || result.error || "Server xatosi yuz berdi");
    }

    return { success: true, data: result };
  } catch (err) {
    console.error("submitForm xato:", err.message);
    return { success: false, error: err.message };
  }
}

export async function fetchAppUrl() {
  try {
    const res = await fetch(`${API_BASE_URL}/app-version`);
    const result = await res.json();

    if (!res.ok) {
      throw new Error(result.error || "Ilova versiyasini olib bo'lmadi");
    }

    return result.url; 
  } catch (err) {
    console.error("fetchAppUrl xato:", err.message);
    return null;
  }
}